import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Config from "src/app.config";
import { setIntegrated } from "src/store/slices/authentication/auth.slice";
import { RootState } from "src/store";
import { isIntegratedSession } from "./isEmbedded";
import useAutoLoginFlow from "./useAutoLoginFlow";
import useIntegratedFlow from "./useIntegratedFlow";
import { AuthFlowName, AuthFlowResult } from "./types";

export default function useAuthFlow(): AuthFlowResult & { flow: AuthFlowName } {
  const dispatch = useDispatch();
  const flow: AuthFlowName = isIntegratedSession() ? "integrated" : (Config.authMode ?? "manual-login");
  // A persisted token (see src/auth/persistedToken.ts) already hydrated state.auth on store creation —
  // e.g. after a same-tab reload from a payment redirect. Skip re-running the flow entirely in that case.
  const hasPersistedToken = !!useSelector((state: RootState) => state.auth.token);

  useEffect(() => {
    dispatch(setIntegrated(flow === "integrated"));
  }, [flow, dispatch]);

  const autoLogin = useAutoLoginFlow(flow === "auto-login" && !hasPersistedToken);
  const integrated = useIntegratedFlow(flow === "integrated" && !hasPersistedToken);

  if (hasPersistedToken) return { flow, isFetching: false };
  if (flow === "integrated") return { flow, ...integrated };
  if (flow === "auto-login") return { flow, ...autoLogin };
  return { flow, isFetching: false };
}
